module.exports = __webpack_public_path__ + "static/img/security-icon1.5ea859a4.png";